import React from "react";
import { FiGrid } from "react-icons/fi";

const PageHeader = ({
  eyebrow,
  title,
  subtitle,
  icon,
  tone = "primary",
  stat,
  actions,
  divider = true,
  className = "",
}) => (
  <header
    className={`page-header page-header--${tone} ${
      divider ? "page-header--divided" : ""
    } ${className}`.trim()}
  >
    <div className="page-header__lead">
      <span className="page-header__icon" aria-hidden="true">
        {icon || <FiGrid />}
      </span>

      <div className="page-header__text">
        {eyebrow ? <span className="page-header__eyebrow">{eyebrow}</span> : null}
        <h1 className="page-header__title">{title}</h1>
        {subtitle ? <p className="page-header__subtitle">{subtitle}</p> : null}
      </div>
    </div>

    {stat || actions ? (
      <div className="page-header__aside">
        {actions ? <div className="page-header__actions">{actions}</div> : null}
        {stat ? (
          <div className="page-header__stat">
            <span className="page-header__stat-label">{stat.label}</span>
            <span className="page-header__stat-value">{stat.value}</span>
          </div>
        ) : null}
      </div>
    ) : null}
  </header>
);

export default PageHeader;
